var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9784 44.314H6.20599C5.38906 44.314 4.72681 44.9762 4.72681 45.7931V47.7949C4.72681 48.6119 5.38906 49.2741 6.20599 49.2741H18.9784C19.7953 49.2741 20.4576 48.6119 20.4576 47.7949V45.7931C20.4576 44.9762 19.7953 44.314 18.9784 44.314Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4404 44.3038L12.5922 3.91425C12.5922 3.49551 12.6747 3.08087 12.835 2.694C12.9952 2.30714 13.2301 1.95562 13.5262 1.65952C13.8223 1.36343 14.1738 1.12855 14.5606 0.968309C14.9475 0.808063 15.3621 0.725586 15.7809 0.725586H34.8066C35.2253 0.725586 35.64 0.808063 36.0269 0.968309C36.4137 1.12855 36.7652 1.36343 37.0613 1.65952C37.3574 1.95562 37.5923 2.30714 37.7526 2.694C37.9128 3.08087 37.9953 3.49551 37.9953 3.91425C37.9953 4.33299 37.9128 4.74763 37.7526 5.1345C37.5923 5.52137 37.3574 5.87288 37.0613 6.16898C36.7652 6.46507 36.4137 6.69995 36.0269 6.86019C35.64 7.02044 35.2253 7.10292 34.8066 7.10292H30.4763C29.6444 7.10292 28.8455 6.77782 28.25 6.19698C27.6544 5.61615 27.3095 4.82558 27.2887 3.99396L27.207 0.725591",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3228 33.4575C31.732 33.0486 32.2869 32.8188 32.8655 32.8188C33.444 32.8188 33.9989 33.0486 34.4082 33.4575",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4653 29.6001C28.898 28.1688 30.8402 27.3647 32.8654 27.3647C34.8905 27.3647 36.8328 28.1688 38.2654 29.6001",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6074 25.7428C26.0636 23.289 29.3935 21.9106 32.8653 21.9106C36.3372 21.9106 39.6671 23.289 42.1232 25.7428",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8686 22.9033L31.167 33.6044",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8655 40.1651C39.7181 40.1651 45.2732 34.6099 45.2732 27.7573C45.2732 20.9047 39.7181 15.3496 32.8655 15.3496C26.0129 15.3496 20.4578 20.9047 20.4578 27.7573C20.4578 34.6099 26.0129 40.1651 32.8655 40.1651Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_1394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon-04.85e7d8e3893f1cf6fdc795687d1e6fe3.svg";
export { ForwardRef as ReactComponent };